import { render, staticRenderFns } from "./SettingDetail.vue?vue&type=template&id=584d2584&"
import script from "./SettingDetail.vue?vue&type=script&lang=ts&"
export * from "./SettingDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports